// extracted by mini-css-extract-plugin
export default {"cls1":"UserCard-cls1_fmn","cls2":"UserCard-cls2_IxY UserCard-cls1_fmn"};